import React from 'react';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { IReducer } from '../../../../../../../../redux/configureStore';
import {
  IClientsData,
  IDateSearch,
} from '../../../../../../../../redux/duck/legado/clientsApp/interface/reduxInterface';
import DownloadBtn from '../../../../../../../../shared/components/buttons/DownloadButton';
import Pdf from '../../../../../../../../shared/components/icons/Pdf';
import ClientsPdfSheet from './components/ClientsPdfSheet';

function ExportPdf(
  totalBalance: number,
  data: IClientsData[],
  date: IDateSearch
) {
  const partnerListState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );

  const componentRef: any = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div>
      <div style={{ display: 'none' }}>
        <ClientsPdfSheet
          state={partnerListState}
          totalBalance={totalBalance}
          data={data}
          date={date}
          ref={componentRef}
        />
      </div>

      <DownloadBtn onClick={handlePrint}>
        <Pdf />
      </DownloadBtn>
    </div>
  );
}

export default ExportPdf;
